import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ExtendedRoutes, NotFoundComponent } from '@increff/commons';
import { LogoutComponent } from './common/components/logout/logout.component';
import { AuthZGuard } from './common/services';
import { LandingComponent } from './components/landing/landing.component';

export const appRoutes: ExtendedRoutes = [
    {
        path: '',
        component: LandingComponent
    },
    {
        path: 'domain',
        loadChildren: () => import('./domain/domain.module').then(m => m.DomainModule),
        data: {
            flow: 'domain'
        }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthZGuard],
        data: {
            flow: 'admin',
            permissions: ['superadmin']
        }
    },
    {
        path: 'logout',
        component: LogoutComponent
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];

/**
 * Main routing module
 */
@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            useHash: true,
            onSameUrlNavigation: 'reload',
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled',
        })
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
